import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetSelection } from "./useGetSelection"
import { SelectionEntity } from "../../Objects/Selection/SelectionEntity"
import { useTranslation } from "react-i18next"

export const useRemoveSelection = () => {
  const { t } = useTranslation("general")
  const { enableLoad, disableLoad } = useLoad()
  const { setError } = useError()
  const { handleGetSelection } = useGetSelection()

  const handleRemoveSelection = async (selection: SelectionEntity, onSuccess: any) => {
    try {
      enableLoad()

      const response = await DeleteRequest(`${API_ROUTES.SELECTION.DELETE}/${selection.id}`)

      if (response.success) {
        await handleGetSelection(onSuccess)
        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleRemoveSelection }
}
